import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to top on every route change.
 * - Uses window.scrollTo({ top: 0, behavior: 'instant' }) — bypasses global CSS
 *   `scroll-behavior: smooth` for immediate reset on navigation.
 * - Preserves anchor navigation (#hash) so in-page links still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Force instant jump by temporarily overriding the CSS scroll-behavior.
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    // Restore CSS smooth scroll for in-page anchors after the frame.
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prev;
    });
  }, [pathname, hash]);

  return null;
}
